<template>
    <v-layout ref="app" class="w-100">
        <!-- In Layout Template -->
        <v-overlay
            v-model="isLoading"
            :scrim="true"
            class="align-center justify-center"
            opacity="0.5"
            persistent
        >
            <div class="text-center">
                <v-progress-linear
                    class="mb-4"
                    color="primary"
                    height="4"
                    indeterminate
                    style="width: 200px;"
                />

                <div v-if="loadingMessage" class="mt-4 text-h6 text-white">
                    {{ loadingMessage }}
                </div>
                <div v-if="loadingSubMessage" class="mt-2 text-body-2 text-grey-lighten-1">
                    {{ loadingSubMessage }}
                </div>
            </div>
        </v-overlay>

        <template v-if="restrictedMode">
            <Restricted/>
        </template>
        <template v-else>
            <sidebar v-if="!fullScreen"/>
            <top-bar v-if="!fullScreen"/>
            <v-main>
                <payment-status-bar v-if="!fullScreen"/>
                <slot></slot>
            </v-main>
            <app-footer v-if="!fullScreen"/>
            <payment-reminder-modal/>
            <tour-manager/>

            <v-btn
                :icon="`mdi-fullscreen${fullScreen?'-exit':''}`"
                class="btn-toggle-screen"
                size="small"
                :aria-label="fullScreen ? 'Exit full screen' : 'Full screen'"
                @click="toggleScreen"
            />
        </template>
    </v-layout>
</template>

<script setup>
import {computed, onMounted, provide, ref} from "vue";
import {storeToRefs} from "pinia";
import {useAuthStore} from "@/stores/authStore";
import TopBar from "@/components/layouts/TopBar.vue";
import {useLoadingStore} from "@/stores/loadingStore";
import Sidebar from "@/components/layouts/Sidebar.vue";
import AppFooter from "@/components/layouts/AppFooter.vue";
import Restricted from "@/components/globals/restricted.vue";
import PaymentStatusBar from "@/components/layouts/PaymentStatusBar.vue";
import PaymentReminderModal from "@/components/dialogs/PaymentReminderModal.vue";
import TourManager from "@/components/layouts/TourManager.vue";
import {useSubscriptionStore} from "@/stores/subscriptionStore";

const authStore = useAuthStore();
const {user, consents} = storeToRefs(authStore);
const fullScreen = ref(false);
// Phone drawer state shared by Sidebar and the TopBar hamburger.
provide('navDrawerOpen', ref(false));
// The Ctrl/Cmd+K search, opened from the Sidebar shortcut or the TopBar search pill.
provide('paletteOpen', ref(false));
const loadingStore = useLoadingStore();
const isLoading = computed(() => loadingStore.isLoading);
const loadingMessage = computed(() => loadingStore.message);
const loadingSubMessage = computed(() => loadingStore.subMessage);

const restrictedMode = computed(() => {
    if (user.value?.type !== 'admin' && user.value?.company) {
        if (user.value?.company?.status === 'restricted' || consents.value) {
            return true;
        }
    }
    return false;
});

const subscriptionStore = useSubscriptionStore();

onMounted(() => {
    if (user.value?.type === 'company' && user.value?.role?.toLowerCase()?.includes('admin')) {
        subscriptionStore.fetchIfStale();
    }
});

const toggleScreen = () => {
    fullScreen.value = !fullScreen.value;
};
</script>

<style scoped>
.btn-toggle-screen {
    right: 3%;
    bottom: 5%;
    z-index: 9999;
    position: fixed;
}
</style>
